'use strict';

angular.module('TurneroApp').component('coMiDoctaIframeComponent', {
    template:
        '<div style="padding:24px;font-family:Segoe UI,Arial,sans-serif;">' +
        '<h2>Turnero Municipalidad</h2>' +
        '<p ng-if="$ctrl.cargando">Estamos validando tu sesión de Mi Docta...</p>' +
        '<div ng-if="$ctrl.error" style="max-width:640px;padding:16px;border:1px solid #f1b0b7;background:#f8d7da;color:#721c24;border-radius:4px;">' +
        '<strong>No pudimos iniciar Turnero.</strong>' +
        '<p style="margin:8px 0 0;">{{ $ctrl.mensajeError }}</p>' +
        '</div>' +
        '</div>',
    controller: ['portal', '$stateParams', '$window', 'loginService', 'TurneroAppConstant', 'seguridadService', 'integracionMiDoctaApiService', 'loginErrorService',
        function (portal, $stateParams, $window, loginService, TurneroAppConstant, seguridadService, integracionMiDoctaApiService, loginErrorService) {
        var ctrl = this;

        ctrl.$onInit = function () {
            ctrl.cargando = true;
            ctrl.error = false;
            ctrl.mensajeError = '';

            if ($stateParams.error) {
                mostrarError();
                return;
            }

            var sesionId = obtenerSesionId();
            if (!sesionId) {
                mostrarError();
                return;
            }

            integracionMiDoctaApiService.validarSesion(sesionId)
                .then(function () {
                    return loginService.Post_Usuario_VeDi().$promise;
                })
                .then(function () {
                    forzarFreshAuthEnSiguienteCarga();
                    return seguridadService.getTokenCidi(true);
                })
                .then(function () {
                    activarModoMiDocta();
                    $window.location.replace(construirUrlDestino());
                })
                .catch(mostrarError);
        };

        function obtenerSesionId() {
            return $stateParams.sesionid || $stateParams.sessionId || $stateParams.sessionid;
        }

        function activarModoMiDocta() {
            try {
                sessionStorage.setItem(TurneroAppConstant.integracionMiDocta.sessionStorageKeyModoCliente, '1');
            } catch (e) { }
        }

        /**
         * Fuerza que la SPA pida `/token` primero después del redirect.
         * Si hay TurneroApp_Authorization viejo en localStorage, seguridadService
         * cree que ya hay sesión Turnero y dispara `/api/...` sin pedir `/token`.
         * Eso entra al PrincipalValidator que devuelve 409 (path != "token") y rompe.
         */
        function forzarFreshAuthEnSiguienteCarga() {
            try { seguridadService.logOut(); } catch (e) { }
            try { sessionStorage.removeItem('ngStorage-usuarioInfo'); } catch (e) { }
        }

        function mostrarError(error) {
            ctrl.cargando = false;
            ctrl.error = true;
            ctrl.mensajeError = loginErrorService.mostrar(error);
        }

        function construirUrlDestino() {
            var base = portal.getUrlServer();
            var query = [TurneroAppConstant.integracionMiDocta.queryParamModoCliente + '=1'];
            var destino = normalizarDestino($stateParams.destino);

            agregarParametro(query, 'idCentroAtencion', $stateParams.idCentroAtencion);
            agregarParametro(query, 'tramitePortal', $stateParams.tramitePortal);
            agregarParametro(query, 'modalidad', $stateParams.modalidad);
            agregarParametro(query, 'idAgenda', $stateParams.idAgenda);

            if (destino === 'misturnos') {
                return base + 'turnos/misturnos?' + query.join('&');
            }

            if (destino === 'tramitealternativa') {
                return base + 'turnos/tramitealternativa?' + query.join('&');
            }

            return base + 'turnos/tramitealternativa?' + query.join('&');
        }

        function normalizarDestino(destino) {
            var valor = (destino || 'tramitealternativa').toLowerCase();
            valor = valor.replace(/^https?:\/\/[^/]+\/?/, '');
            valor = valor.replace(/^\/+/, '');

            if (valor === 'mis-turnos' || valor === 'misturnos' || valor === 'turnos/misturnos') {
                return 'misturnos';
            }

            if (valor === 'tramite-alternativa' || valor === 'tramitealternativa' || valor === 'turnos/tramitealternativa') {
                return 'tramitealternativa';
            }

            return valor;
        }

        function agregarParametro(query, nombre, valor) {
            if (valor !== undefined && valor !== null && valor !== '') {
                query.push(nombre + '=' + encodeURIComponent(valor));
            }
        }
    }]
});



// WEBPACK FOOTER //
// ./app/shared/integracionMiDocta/miDoctaIframeComponent.js